import React from 'react';
import PropTypes from 'prop-types';
import {Button} from "@material-ui/core";
import {Link} from "react-router-dom";

export default function RouterLinkSmallBtn(props) {
    return (
        <div style={{display: "flex", justifyContent: "center"}}>
            <Button disabled={props.disabled} variant="contained" color="primary" component={Link} to={props.to}
                    style={{
                        height: 25,
                        borderRadius: 50,
                        fontSize: 12,
                        paddingTop: 6,
                        paddingBottom: 6,
                        paddingLeft: 8,
                        paddingRight: 8
                    }}>
                {props.children}
            </Button>
        </div>
    );
}

RouterLinkSmallBtn.propTypes = {
    children: PropTypes.node,
};